import React from 'react';

/**
 * 部門名稱
 * @param {*} param0 
 */
export function ItemDepartmentName({departmentName, setDepartmentName}){
    return (
        <div className="row">
            <div className="col-sm-12">
                <div className="form-group">
                    <label htmlFor="exampleInputEmail1">部門名稱</label>
                    <input type="text" className="form-control" placeholder="" value={departmentName} onChange={e=>setDepartmentName(e.target.value)} />
                    </div>
            </div>
        </div>
    )
}


/**
 * 部門列表(下拉選單)
 * @param {*} param0 
 */
export function ItemDepartmenListSelect({departmentList, managerDepartmentId, setManagerDepartmentId}){
    return (
        <div className="row">
                <div className="col-sm-12">
                    <div className="form-group">
                        <label htmlFor="exampleInputEmail1">主管部門</label>
                        
                        <select className="form-control" onChange={e=>setManagerDepartmentId(e.target.value)}  value={managerDepartmentId}>
                            <option value=""></option>
                            {
                            departmentList.map((department)=>(
                                <option key={department.departmentId}  value={department.departmentId} >{department.departmentName}</option>
                            ))
                            }
                        </select>
                    </div>
                </div>
        </div>
    )
}